import React, { useMemo, useState } from "react";
import { Modal, Tabs, Input, Spin, Empty, List, Space, Button } from "antd";
import { useTranslation } from "react-i18next";
import { CopyOutlined, EyeOutlined } from "@ant-design/icons";
import { EvaluationItemCard } from "../../uiComponents/EvaluationItemCard/EvaluationItemCard";
import "./SharedEvaluationsModal.scss";

export function SharedEvaluationsModal({
  isOpen,
  onClose,
  loading,
  evaluations = [],
  onView,
  onClone,
}) {
  // "Ver" ya existe en common: no se duplica en este namespace.
  const { t } = useTranslation(["evaluations", "common"]);

  const [q, setQ] = useState("");
  const [tab, setTab] = useState("all"); // all | global | institution

  const filtered = useMemo(() => {
    const query = q.trim().toLowerCase();
    let list = Array.isArray(evaluations) ? evaluations : [];

    if (tab === "global") {
      list = list.filter(
        (e) => e.type === "standardized" || e.visibility === "global",
      );
    } else if (tab === "institution") {
      list = list.filter(
        (e) => e.type === "custom" && e.visibility === "public",
      );
    }

    if (!query) return list;
    return list.filter((e) => (e.title || "").toLowerCase().includes(query));
  }, [evaluations, q, tab]);

  return (
    <Modal
      title={t("compartidas.titulo")}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={1100}
      centered
      destroyOnHidden
      className="revi-shared-evals-modal"
    >
      <div className="revi-shared-evals-modal__toolbar">
        <Input.Search
          placeholder={t("compartidas.buscarPlaceholder")}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          allowClear
          style={{ width: 320 }}
        />
      </div>

      <Tabs
        activeKey={tab}
        onChange={setTab}
        items={[
          { key: "all", label: t("compartidas.tabs.todas") },
          { key: "global", label: t("compartidas.tabs.globales") },
          { key: "institution", label: t("compartidas.tabs.institucion") },
        ]}
      />

      {loading ? (
        <div className="revi-shared-evals-modal__center">
          <Spin size="large" />
        </div>
      ) : filtered.length === 0 ? (
        <div className="revi-shared-evals-modal__center">
          <Empty description={t("compartidas.vacio")} />
        </div>
      ) : (
        <List
          grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 4 }}
          dataSource={filtered}
          renderItem={(ev) => (
            <List.Item>
              <div className="revi-shared-evals-modal__item">
                <EvaluationItemCard
                  evaluation={ev}
                  mode="shared"
                  onView={() => onView?.(ev)}
                />

                <Space
                  style={{
                    marginTop: 10,
                    width: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button icon={<EyeOutlined />} onClick={() => onView?.(ev)}>
                    {t("common:actions.view")}
                  </Button>
                  <Button
                    type="primary"
                    icon={<CopyOutlined />}
                    onClick={() => onClone?.(ev)}
                  >
                    {t("compartidas.clonar")}
                  </Button>
                </Space>
              </div>
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
}
